/**
 * Black Friday Countdown Timer using Theme Settings
 * Connects to date_picker_start and date_picker_end settings
 */

class DevFridayTimer {
  constructor() {
    this.elements = {
      days: null,
      hours: null,
      minutes: null,
      seconds: null,
      container: null
    };
    this.interval = null;
    this.startDate = null;
    this.endDate = null;
    
    this.init();
  }

  init() {
    // Find timer elements
    this.elements.days = document.querySelector('[data-timer-days]');
    this.elements.hours = document.querySelector('[data-timer-hours]');
    this.elements.minutes = document.querySelector('[data-timer-minutes]');
    this.elements.seconds = document.querySelector('[data-timer-seconds]');

    // Check if we have at least one timer element
    if (!this.elements.days && !this.elements.hours && !this.elements.minutes && !this.elements.seconds) {
      return;
    }

    this.initializeTimer();
    this.startCountdown();
  }

  initializeTimer() {
    // Get theme settings from global Shopify object or meta tags
    const startDateStr = this.getThemeSetting('date_picker_start') || '10-15-2025';
    const endDateStr = this.getThemeSetting('date_picker_end') || '10-22-2025';
    
    // Parse dates (format: mm-dd-yyyy)
    this.startDate = this.parseDate(startDateStr);
    this.endDate = this.parseDate(endDateStr);
    
    console.log('Timer dates:', { start: this.startDate, end: this.endDate });
  }

  getThemeSetting(key) {
    // Try to get from window.theme object first
    if (window.theme && window.theme.settings && window.theme.settings[key]) {
      return window.theme.settings[key];
    }
    
    // Try to get from meta tag
    const metaTag = document.querySelector(`meta[name="theme-setting-${key}"]`);
    if (metaTag) {
      return metaTag.getAttribute('content');
    }
    
    // Fallback to data attributes on body or html
    const bodyData = document.body.getAttribute(`data-${key.replace(/_/g, '-')}`);
    if (bodyData) {
      return bodyData;
    }
    
    return null;
  }

  parseDate(dateStr) {
    // Parse mm-dd-yyyy format
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      const month = parseInt(parts[0]) - 1; // Month is 0-indexed
      const day = parseInt(parts[1]);
      const year = parseInt(parts[2]);
      return new Date(year, month, day);
    }
    return new Date();
  }

  startCountdown() {
    this.updateDisplay();
    
    this.interval = setInterval(() => {
      this.updateDisplay();
    }, 1000);
  }

  updateDisplay() {
    const now = new Date();
    const remaining = this.endDate.getTime() - now.getTime();

    if (remaining <= 0) {
      this.onTimerExpired();
      return;
    }

    // Calculate time units
    const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

    // Update display with zero-padding
    if (this.elements.days) {
      this.elements.days.textContent = days.toString().padStart(2, '0');
    }
    if (this.elements.hours) {
      this.elements.hours.textContent = hours.toString().padStart(2, '0');
    }
    if (this.elements.minutes) {
      this.elements.minutes.textContent = minutes.toString().padStart(2, '0');
    }
    if (this.elements.seconds) {
      this.elements.seconds.textContent = seconds.toString().padStart(2, '0');
    }
  }

  onTimerExpired() {
    clearInterval(this.interval);
    
    // Display expired state - show all zeros
    if (this.elements.days) this.elements.days.textContent = '00';
    if (this.elements.hours) this.elements.hours.textContent = '00';
    if (this.elements.minutes) this.elements.minutes.textContent = '00';
    if (this.elements.seconds) this.elements.seconds.textContent = '00';
    
    // Add expired class for styling
    const timerContainer = document.querySelector('.dev-friday-hero-content-top-timer');
    if (timerContainer) {
      timerContainer.classList.add('timer-expired');
    }
  }

  // Public method to get remaining time
  getRemainingTime() {
    const now = new Date();
    return Math.max(0, this.endDate.getTime() - now.getTime());
  }

  // Public method to check if timer is expired
  isExpired() {
    return this.getRemainingTime() <= 0;
  }
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.devFridayTimer = new DevFridayTimer();
});

// Also initialize immediately if DOM is already loaded
if (document.readyState === 'loading') {
  // DOM is still loading, wait for DOMContentLoaded
} else {
  // DOM is already loaded
  window.devFridayTimer = new DevFridayTimer();
}
